import { httpReducer } from "../lib/create-action";
import { statsOptionsActionName } from "../actions/stats_options";
import get from "lodash/get";

export default httpReducer(
  statsOptionsActionName,
  {
    isLoading: false,
    os: [],
    device: [],
    app: [],
  },
  {
    success: (state, action) => {
      return { ...state, ...get(action, "payload.resp", {}) };
    },
  }
);
